import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/styles/main.sass'
import pt from 'vuetify/lib/locale/pt'
import { lightTheme, darkTheme } from '@/themes/defaultTheme'

Vue.use(Vuetify)

export default new Vuetify({
  lang:{
    locales: {pt},
    current: "pt",
  },
  icons: {
    iconfont: 'fa'
  },
  theme: {
    themes: {
      light: lightTheme,
      dark: darkTheme,
    },
    options: {
      customProperties: true,
      minifyTheme: function (css) {
        return css.replace(/[\r\n|\r|\n]/g, '')
      },
    },
  }
})